import React, { Component } from "react";
import SearchIcon from "@mui/icons-material/Search";
import CancelIcon from "@mui/icons-material/Cancel";
import makeStyles from "@mui/styles/makeStyles";
import withStyles from "@mui/styles/withStyles";
import PropTypes from "prop-types";
import { TextField, IconButton } from "@mui/material";

const styles = theme => ({
  search: {
    backgroundColor: ({ background }) => background,
    color: theme.palette.text.primary
  }
});

const useSearchBarButtonStyles = makeStyles(theme => ({
  iconButton: {
    transform: "scale(1, 1)",
    transition: "transform 200ms cubic-bezier(0.4, 0.0, 0.2, 1)"
  },
  icon: {
    transition: "opacity 200ms cubic-bezier(0.4, 0.0, 0.2, 1)"
  }
}));

function SearchBarButton(props) {
  const { value, handleRequestSearch, handleClear } = props;
  const classes = useSearchBarButtonStyles();
  return !value ? (
    <IconButton
      className={classes.iconButton}
      aria-label="Search"
      onClick={handleRequestSearch}
      size="large"
    >
      <SearchIcon classes={{ root: classes.icon }} />
    </IconButton>
  ) : (
    <IconButton
      className={classes.iconButton}
      aria-label="Clear"
      onClick={handleClear}
      size="large"
    >
      <CancelIcon classes={{ root: classes.icon }} />
    </IconButton>
  );
}

class SearchBar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentSearchInput: this.props.value ? this.props.value : ""
    };
  }

  handleInput = e => {
    this.setState({ currentSearchInput: e.target.value });
    if (this.props.onSearchInput) {
      this.props.onSearchInput(e.target.value);
    }
  };

  handleClear = () => {
    this.setState({ currentSearchInput: "" });
    if (this.props.onSearchSubmit) {
      this.props.onSearchSubmit("");
    }
    if (this.props.onSearchInput) {
      this.props.onSearchInput("");
    } else if (this.props.onSearchClear) {
      this.props.onSearchClear();
    }
  };

  handleRequestSearch = () => {
    this.searchInput.focus();
  };

  handleKeyPress = event => {
    if (event.keyCode === 13 && this.props.onSearchSubmit) {
      this.props.onSearchSubmit(this.state.currentSearchInput);
    }
  };

  render() {
    const {
      classes,
      searchIconPosition,
      placeholder,
      filled,
      disableUnderline,
      controlled,
      value
    } = this.props;
    const { currentSearchInput } = this.state;
    const currentSearchValue = controlled ? value : currentSearchInput;
    const searchBarButton = (
      <SearchBarButton
        handleRequestSearch={this.handleRequestSearch}
        handleClear={this.handleClear}
        value={currentSearchValue}
      />
    );
    return (
      <TextField
        fullWidth
        InputProps={{
          className: classes.search,
          startAdornment: searchIconPosition === "start" && searchBarButton,
          endAdornment: searchIconPosition === "end" && searchBarButton,
          inputProps: {
            "aria-label": "Search",
            onKeyDown: this.handleKeyPress,
            "data-qa": "search-bar-input"
          },
          disableUnderline
        }}
        placeholder={placeholder}
        inputRef={input => (this.searchInput = input)}
        value={currentSearchValue}
        onChange={this.handleInput}
        variant={filled ? "filled" : "standard"}
        data-qa="search-bar"
        hiddenLabel
      />
    );
  }
}

export default withStyles(styles, { withTheme: true })(SearchBar);

SearchBar.propTypes = {
  searchIconPosition: PropTypes.oneOf(["start", "end"]),
  placeholder: PropTypes.string,
  background: PropTypes.string,
  onSearchInput: PropTypes.func,
  onSearchSubmit: PropTypes.func,
  onSearchClear: PropTypes.func,
  value: PropTypes.string,
  disableUnderline: PropTypes.bool,
  filled: PropTypes.bool
};

SearchBar.defaultProps = {
  searchIconPosition: "start",
  value: "",
  background: "#fff",
  filled: false,
  disableUnderline: true
};
